module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-a91443d0e9d4dcacb7dc862b085b2dce.png";